import { questions } from './HeizungsCheck.config.js';
import { QuestionsComponent } from './components/QuestionsComponent';
import { Result } from './components/Result';
import { useHeizungsCheck } from './hooks/useHeizungsCheck';
import styles from './HeizungsCheck.module.scss';
import React from 'react';

const HeizungsCheck = () => {
  const {
    CurrentStepComponent,
    handleBackClick,
    handleNextClick,
    heatPotential,
    isFinalStep,
    results,
    step,
    localref,
  } = useHeizungsCheck();

  return (
    <div aria-label="Heizungscheck" className={styles.container} ref={localref}>
      {!!CurrentStepComponent && (
        <QuestionsComponent
          handleBackClick={handleBackClick}
          handleNextClick={handleNextClick}
          {...questions[step - 1]}
        />
      )}
      {isFinalStep && (
        <Result heatPotential={heatPotential} results={results} />
      )}
    </div>
  );
};

export { HeizungsCheck };
